import { Injectable } from '@angular/core';
import { DatasetClientService } from '@mode/dataset/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, tap } from 'rxjs';
import { catchError, concatMap, map, mergeMap, switchMap } from 'rxjs/operators';
import { ToastService } from '@mode/shared/util-toast';
import * as DatasetsActions from './datasets.actions';

export interface DatasetActionType {
  org: string;
  datasetType: string;
  pageNum: number;
  searchTerm: string;
  tabType: string;
}
@Injectable()
export class DatasetsEffects {
  loadDatasetBrowserData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DatasetsActions.loadDatasetBrowserData),
      mergeMap((action) => this.loadDatasets(action))
    )
  );

  loadDatasetDataWithSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DatasetsActions.loadDatasetDataWithSearch),
      switchMap((action) => this.loadDatasets(action))
    )
  );

  private loadDatasets(action: DatasetActionType) {
    const { org, datasetType, pageNum, searchTerm, tabType } = action;
    return this.datasetClientService.getImportableDatasetsBrowserData(org, datasetType, pageNum, searchTerm).pipe(
      map((response) =>
        DatasetsActions.loadDatasetBrowserDataSuccess({
          datasetBrowserData: response.datasetBrowserData,
          pagination: response.pagination,
          tabType,
        })
      ),
      catchError(() => {
        this.toastService.error('Failed to retrieve importable datasets');
        return of(DatasetsActions.loadDatasetBrowserDataFailure());
      })
    );
  }

  constructor(
    private actions$: Actions,
    private datasetClientService: DatasetClientService,
    private toastService: ToastService
  ) {}
}
